module.exports = __webpack_public_path__ + "e72f9dd483c9c1fded842f04eeb2f597.png";